<template>
    <div>
        <div class="text-center">
            <h3>บันทึกรับ (กรณีไม่มีเก็บ)</h3>
            <br>
            <b-row sm="10">
                <b-col sm="5" class="col text-right">
                    <label  class="col-form-label">วันที่รับ</label>
                </b-col>
                <b-col sm="5">
                    <date-picker
                            v-model="date"
                            type="date"
                            format="DD/MM/YYYY"
                            lang="en">
                    </date-picker>


                </b-col>
            </b-row>
            <b-row sm="10">
                <b-col sm="5" class="col text-right">
                    <label  class="col-form-label">เลขที่ใบแจ้งหนี้</label>
                </b-col>
                <b-col sm="5" class="text-left">
                    <label  class="col-form-label ">
                        {{InvoiceForm.invoice_id}}
                    </label>
                </b-col>
            </b-row>
            <b-row sm="10">
                <b-col sm="5" class="col text-right">
                    <label  class="col-form-label ">วันที่ใบแจ้งหนี้</label>
                </b-col>
                <b-col sm="5" class="text-left">
                    <label  class="col-form-label">
                        {{InvoiceForm.date | moment("DD/MM/YYYY")}}
                    </label>
                </b-col>
            </b-row>
            <b-row sm="10">
                <b-col sm="5" class="col text-right">
                    <label  class="col-form-label">ยอดเงิน</label>
                </b-col>
                <b-col sm="5" class="text-left">
                    <label  class="col-form-label">
                        {{InvoiceForm.total | currency}}
                    </label>
                </b-col>
            </b-row>
            <b-row sm="10">
                <b-col sm="5" class="col text-right">
                    <label  class="col-form-label">เซลล์</label>
                </b-col>
                <b-col sm="5" class="text-left">
                    <label  class="col-form-label">
                        <template v-if="InvoiceForm.sale">
                            {{InvoiceForm.sale.name}}
                        </template>
                        <template v-else>
                            -
                        </template>
                    </label>
                </b-col>
            </b-row>
            <b-row sm="10">
                <b-col sm="5" class="col text-right">
                    <label  class="col-form-label">รหัสลูกค้า</label>
                </b-col>
                <b-col sm="5" class="text-left">
                    <label  class="col-form-label">
                        <template v-if="InvoiceForm.customer">
                            {{InvoiceForm.customer.customer_id}}
                        </template>
                        <template v-else>
                            -
                        </template>
                    </label>
                </b-col>
            </b-row>
            <b-row sm="10">
                <b-col sm="5" class="col text-right">
                    <label  class="col-form-label">ชื่อลูกค้า</label>
                </b-col>
                <b-col sm="5" class="text-left">
                    <label  class="col-form-label">
                        <template v-if="InvoiceForm.customer">
                            {{InvoiceForm.customer.name}}
                        </template>
                        <template v-else>
                            -
                        </template>
                    </label>
                </b-col>
            </b-row>
            <b-row sm="10">
                <b-col sm="5" class="col text-right">
                    <label  class="col-form-label">บันทึกโดย</label>
                </b-col>
                <b-col sm="5" class="text-left">
                    <label  class="col-form-label">
                        {{user.name}}
                    </label>
                </b-col>
            </b-row>
            <br>
        </div>
        <div v-if="InvoiceForm.save_exportation && InvoiceForm.save_exportation.length > 0 && InvoiceForm.save_exportation[0].image_file" class="mb-3">
            <b-row>
                <b-col cols="3" v-for="(x,i) in InvoiceForm.save_exportation[0].image_file.split(',')" v-if="i != InvoiceForm.save_exportation[0].image_file.split(',').length-1">
                        <img :src="domain.slice(0, -4)+'/file/'+x" v-img alt="" style="width: 80px;height: auto">
                </b-col>
            </b-row>
        </div>
        <div class="col text-center">
            <button @click="submitData"
                    type="button"
                    class="btn btn-success">
                <icon name="save" style="width: 25px"></icon>
                บันทึก</button>&nbsp&nbsp
            <button @click="cancelData"
                    type="button"
                    class="btn btn btn-outline-secondary">
                <icon name="times" style="width: 25px"></icon> ยกเลิก
            </button>
        </div>
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import moment from "moment";
    import DatePicker from 'vue2-datepicker';
    import {domain} from "@/util/Constants";

    export default {
        components: {
            DatePicker
        },
        name: "invoice-save-exportation-modal",
        data(){
            return {
                date : "",
                domain : domain
            }
        },
        created(){
            this.getCurrentDate();
        },
        computed:{
            ...mapState({
                InvoiceList: state => {
                    return state.Invoice.InvoiceList;
                },
                InvoiceForm:state=>{
                    return  state.Invoice.invoiceForm;
                },
                user:state=>{
                    return state.Auth.user
                },
            }),
        },
        methods:{
            getCurrentDate(){
                let datenow = moment().format("YYYY-MM-DD");
                this.date = datenow;
            },
            submitData(){
                if(!this.date){
                    alert("กรุณาเลือกวันที่รับ")
                }
                else{
                    this.date = moment(this.date).format("YYYY-MM-DD");

                    let details = [{
                        invoice_id : this.InvoiceForm.id,
                        customer_id : this.InvoiceForm.customer_id,
                        billing_id : "",
                        billing_number : '',
                        date : this.InvoiceForm.date,
                        remaining_payoff : this.InvoiceForm.total,
                        amount : 0,
                        balance : 0,
                        receive_status : 1,
                        receive_amount_status : "",
                    }];
                    let data = {
                        invoice_id : this.InvoiceForm.id,
                        id : "",
                        balance : 0,
                        is_sell : "",
                        acc : "",
                        pledge_amount : "",
                        fee_amount : "",
                        overpay : "",
                        arrears : "",
                        date : this.date,
                        user_id : this.user.id,
                        amount : this.InvoiceForm.total,
                        sale_id : this.InvoiceForm.sale_id,
                        customer_id : this.InvoiceForm.customer_id,
                        total : this.InvoiceForm.total,
                        details : details,
                        transactions : [],
                    };
                this.$emit('submit',data);
                }
            },
            cancelData(){
                this.$emit('submit',0);
            }
        }
    }
</script>

<style scoped>

</style>
